import axios from 'axios';
import { store } from '../store';
import config from '../config/index';

const HubspotService = {
  async getVisitorToken(visitor) {
    const { loginReducer } = store.getState();
    const { token } = loginReducer;

    try {
      const {
        data: { data },
      } = await axios.get(`${config.apiUrl}/hubspot/token`, {
        data: visitor,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (e) {
      return null;
    }
  },
};

export default HubspotService;
